import React, { useState } from 'react';

import { FormComponent, UiComponent } from 'components';
import { PushStatus, PushType, SearchPushFilterType } from 'types';
import dayjs from 'dayjs';
import { PUSH_STATUS_OPTIONS, PUSH_TYPE_OPTIONS } from '../constants';
import { periodWrap, period, tilde } from './style';

interface Props {
  handleFilter: (filter: SearchPushFilterType) => void;
}

const GUIDE = `입력 중 Enter 로 바로 검색할 수 있어요.
발송 기간은 발송 완료 건은 실제 발송일, 예약 건은 예약일 기준이에요.`;

function Filter({ handleFilter }: Props) {
  const [pushType, setPushType] = useState<PushType | ''>('');
  const [status, setStatus] = useState<PushStatus | ''>('');
  const [start, setStart] = useState<Date | null>(null);
  const [end, setEnd] = useState<Date | null>(null);

  const handleSubmit = ({ title }: { title?: string }) => {
    handleFilter({
      ...(title ? { title } : {}),
      ...(pushType ? { pushType } : {}),
      ...(status ? { status } : {}),
      ...(start ? { startDate: dayjs(start).format('YYYY-MM-DD') } : {}),
      ...(end ? { endDate: dayjs(end).format('YYYY-MM-DD') } : {}),
    });
  };

  return (
    <FormComponent.Form submit={handleSubmit}>
      <FormComponent.SearchInput
        name="title"
        placeholder="제목으로 검색해주세요"
      />
      <FormComponent.Dropdown
        title="유형"
        options={PUSH_TYPE_OPTIONS}
        value={pushType}
        handleChange={(value) => setPushType(value as PushType | '')}
      />
      <FormComponent.Dropdown
        title="상태"
        options={PUSH_STATUS_OPTIONS}
        value={status}
        handleChange={(value) => setStatus(value as PushStatus | '')}
      />
      <div css={periodWrap}>
        <div css={period}>
          <FormComponent.DatePicker
            date={start}
            handleChange={setStart}
            maxDate={end}
            placeholderText="발송 시작일"
          />
        </div>
        <span css={tilde}>~</span>
        <div css={period}>
          <FormComponent.DatePicker
            date={end}
            handleChange={setEnd}
            minDate={start}
            placeholderText="발송 종료일"
          />
        </div>
      </div>
      <UiComponent.Button
        variant="contained"
        color="primary"
        type="submit"
        css={{ height: '40px' }}
      >
        검색
      </UiComponent.Button>
      <UiComponent.Tooltip content={GUIDE} label="검색 안내" />
    </FormComponent.Form>
  );
}

export default Filter;
